import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AuthApiClient } from 'src/app/shared/services/ppv.api'

@Injectable({ providedIn: 'root' })
export class ReportService {
   constructor(private authServiceClient: AuthApiClient) {}

   // Function to fetch the token from your local server
   fetchToken(): Observable<string> {
      return this.authServiceClient.getTableauEmbedLink()
   }

   handleLoadError(e) {
      const message = JSON.parse(e.detail.message)
      console.log(message)
      // do something based on the error code in e.detail
   }
}
